import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/settlement",
    icon: "android-menu",
    title: "结算管理",
    name: 'Settlement',
    component: Main,
    children: [
      {
        path: "notOrder",
        title: "非订单类结算",
        name: 'SettlementNotOrder',
        component: resolve => {
          require(["@/views/settlement/notOrder.vue"], resolve);
        }
      },
      {
        path: "compensation",
        title: "履约扣款",
        name: 'SettlementCompensation',
        component: resolve => {
          require(["@/views/settlement/compensation.vue"], resolve);
        }
      },
      {
        path: "amountConfirm",
        title: "售前金额确认",
        name: 'SettlementAmountConfirm',
        component: resolve => {
          require(["@/views/settlement/amountConfirm.vue"], resolve);
        }
      },
      {
        path: "docManage",
        title: "结算单据管理",
        name: 'SettlementDocManage',
        component: resolve => {
          require(["@/views/settlement/docManage.vue"], resolve);
        }
      },
      {
        path: "notSettleOrder",
        title: "不可结算订单",
        name: 'SettlementNotSettleOrder',
        component: resolve => {
          require(["@/views/settlement/notSettleOrder.vue"], resolve);
        }
      },

      // ── CN 路由 ──
      {
        path: "cn/notOrder",
        title: "非订单类结算(CN)",
        name: 'SettlementNotOrderCn',
        component: resolve => {
          require(["@/views/settlement/cn/notOrder.vue"], resolve);
        }
      },
      {
        path: "cn/compensation",
        title: "履约扣款(CN)",
        name: 'SettlementCompensationCn',
        component: resolve => {
          require(["@/views/settlement/cn/compensation.vue"], resolve);
        }
      },
      {
        path: "cn/amountConfirm",
        title: "售前金额确认(CN)",
        name: 'SettlementAmountConfirmCn',
        component: resolve => {
          require(["@/views/settlement/cn/amountConfirm.vue"], resolve);
        }
      },
      {
        path: "cn/docManage",
        title: "结算单据管理(CN)",
        name: 'SettlementDocManageCn',
        component: resolve => {
          require(["@/views/settlement/cn/docManage.vue"], resolve);
        }
      },
      {
        path: "cn/notSettleOrder",
        title: "不可结算订单(CN)",
        name: 'SettlementNotSettleOrderCn',
        component: resolve => {
          require(["@/views/settlement/cn/notSettleOrder.vue"], resolve);
        }
      },
    ]
  }
]

export default customerRoutes
